'use client';

import { memo } from 'react';

import { Spinner } from '@air/primitive-spinner';

import { AirLogo } from '~/components/auth/AirLogo';
import { VerifyUser } from '~/components/auth/VerifyUser';
import { useVerifyUserScreen } from '~/hooks/useVerifyUserScreen';

export type VerifyUserScreenProps = {
  onLogout: () => void;
  onUnauthenticated: () => void;
  onVerified: () => void;
};

export const VerifyUserScreen = memo(({ onLogout, onUnauthenticated, onVerified }: VerifyUserScreenProps) => {
  const { canShowPage, email, isRefreshing, refreshUserVerification } = useVerifyUserScreen({
    onUnauthenticated,
    onVerified,
  });

  return (
    <main
      className="flex min-h-screen flex-col items-center justify-center gap-8 bg-neutral-3 p-8"
      data-testid="VERIFY_USER_SCREEN"
    >
      <AirLogo />
      <div className="w-full max-w-sm overflow-hidden rounded-16 bg-neutral-1 shadow-card">
        <div className="flex flex-col items-center gap-4 p-8">
          <h1 className="font-semibold text-24 text-neutral-12 leading-snug tracking-normal">Verify your email</h1>
          {canShowPage && email ? (
            <VerifyUser
              email={email}
              isRefreshing={isRefreshing}
              onLogout={onLogout}
              onRefresh={refreshUserVerification}
            />
          ) : (
            <Spinner className="size-8 text-brand-9" />
          )}
        </div>
      </div>
    </main>
  );
});

VerifyUserScreen.displayName = 'VerifyUserScreen';
